import Layout from '../components/Layout'
import { PageHeader, Section, Card } from '../components/UIComponents'
import { useUser, SignOutButton } from '@clerk/clerk-react'

export default function Profile() {
  const { user } = useUser()

  return (
    <Layout>
      <div className="space-y-8 max-w-4xl mx-auto">
        <PageHeader
          icon="👤"
          title="Profile"
          description="Manage your personal information"
        />

        <Section title="Personal Information">
          <Card>
            <div className="space-y-4">
              <div className="flex items-center gap-4">
                {user?.imageUrl && (
                  <img
                    src={user.imageUrl}
                    alt={user.firstName || 'User'}
                    className="w-16 h-16 rounded-lg"
                  />
                )}
                <div>
                  <p className="text-white font-semibold text-lg">
                    {user?.firstName} {user?.lastName}
                  </p>
                  <p className="text-slate-400 text-sm">
                    {user?.emailAddresses[0]?.emailAddress}
                  </p>
                </div>
              </div>
            </div>
          </Card>
        </Section>

        <Section title="Account Settings">
          <Card>
            <div className="space-y-3">
              <div className="flex items-center justify-between p-3 bg-slate-800/50 rounded-lg">
                <span className="text-slate-300">Notifications</span>
                <input type="checkbox" className="w-4 h-4" defaultChecked />
              </div>
              <div className="flex items-center justify-between p-3 bg-slate-800/50 rounded-lg">
                <span className="text-slate-300">Two-factor authentication</span>
                <button className="text-blue-400 text-sm font-semibold">Enable</button>
              </div>
            </div>
          </Card>
        </Section>

        <Section title="Actions">
          <SignOutButton>
            <button className="w-full px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors">
              Sign out
            </button>
          </SignOutButton>
        </Section>
      </div>
    </Layout>
  )
}
